import script from "./RadiologyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RadiologyCard.vue?vue&type=script&setup=true&lang=js"

import "./RadiologyCard.vue?vue&type=style&index=0&id=3211858e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3211858e"]])

export default __exports__